// extracted by mini-css-extract-plugin
export default {"badge":"styles_badge__hyihs","documents-controls":"styles_documents-controls__xwmQa"};